import {
  Component,
  OnInit,
  AfterViewInit,
  Input, Output, EventEmitter, ElementRef, ViewChild, OnChanges, SimpleChanges
} from '@angular/core';

@Component({
  selector: 'app-tab',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss']
})

export class TabComponent implements OnChanges, OnInit, AfterViewInit {
  @Input()
  tab;

  @Input()
  tabIndex;

  @Input()
  activeTab;

  private _name: string;

  @Input()
  tabStyle;

  @Input()
  tabActiveStyle;

  @Input()
  tabHoveredStyle;

  @Output()
  hoverEvent = new EventEmitter<any>();

  @Output()
  activeEvent = new EventEmitter<any>();

  @Output()
  clickEvent = new EventEmitter<any>();

  @Output()
  tabChangeEvent = new EventEmitter<any>();

  @ViewChild('elTab',{static:true})
  elTab: ElementRef;

  hovered = false;

  public styles: any = {
    'padding': '16px 24px',
    'color': '#707070',
    'display': 'block',
    'cursor': 'pointer'
  };

  public hoveredStyles: any = {
    'color': '#389FFF'
  };

  public activeStyles: any = {
    'color': '#389FFF'
  };

  constructor() { }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.activeTab) {
      if (changes.activeTab.previousValue !== undefined && changes.activeTab.currentValue === this.tabIndex) {
        this.tabChangeEvent.emit({ index: this.activeTab, elem: this.elTab });
      }
    }
  }

  ngAfterViewInit() {
    const timer = setTimeout(() => {
      if (this.tabIndex === this.activeTab) {
        this.activeEvent.emit({ index: this.activeTab, elem: this.elTab, init: true });
        clearTimeout(timer);
      }
    }, 100);
  }

  onMouseEnter(event) {
    this.hovered = true;
    this.hoverEvent.emit({ index: this.tabIndex, elem: this.elTab, init: false });
  }

  onMouseLeave(event) {
    this.hovered = false;
  }

  onClick($event) {
    this.clickEvent.emit({ index: this.tabIndex, elem: this.elTab, init: false });
  }

  getHoveredStyle() {
    return { ...this.styles, ...this.tabStyle, ...this.hoveredStyles, ...this.tabHoveredStyle };
  }

  getActiveStyle() {
    return { ...this.styles, ...this.tabStyle, ...this.activeStyles, ...this.tabActiveStyle };
  }

  getStyle() {
    return { ...this.styles, ...this.tabStyle };
  }
}
